import { CommonMutationCrumbs } from './breadcrumb';

export const SearchPersonCitizenshipCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Ricerca persona - Registrazione Cittadinanza',
    path: '/mutazioni/persona/cittadinanza',
  },
];

export const RegistrationCitizenshipCrumbs = [
  ...SearchPersonCitizenshipCrumbs,
  {
    name: 'Registrazione Cittadinanza',
    path: '/mutazioni/persona/cittadinanza/registrazione',
  },
];
